export const CustomerFacingErrorMessages = {
  billingAddressSelection: "Please select or add a billing address",
  deliveryOptionSelection: "Please select a delivery option.",
  emailRequired: "Please enter an email address to continue.",
  unableToUpdateEmail: "We couldn't save your email address. Please try again.",
  missingCreditCardDetails: "Please enter your credit card details.",
  reenterCardNumber: "Please re-enter your card number to update the expiration date or CVV.",
  paypalInitiation: "There was an error initializing your PayPal payment. Please try again.",
  paymentMethodDeclined: `Your payment method was declined. Please try again, or select a new payment.`,
  paymentProcessing: `There was an error processing your payment. Please try again, or select a new payment method.`,
  paymentProcessorIssue:
    "There's an issue with our payment processor. Please use PayPal while it is being resolved or check back shortly.",
  shippingAddressSelection: "Please select or add a shipping address.",
  unableToAddNewShippingAddressToCart: "Failed to add new shipping address, please try again.",
  unableToGetAddresses: "There was an error getting your saved addresses. Please try to refresh, or add a new address.",
  unableToLoadAddresses: "There was an error getting your saved addresses.",
  unableToLoadSavedCards: "There was an error getting your saved payment methods.",
  unableToLoadAccount: "There was an error loading your account.",
  unableToGetSavedCards:
    "There was an error getting your saved payment methods. Please try to refresh, or add a new card.",
  unableToSaveShippingAddressToCart: "We couldn't save your shipping address. Please try again.",
  unableToSaveToAddressesBook:
    "We couldn't save your address for future orders. You can continue with your checkout, or try again later.",
  unableToUpdateBillingAddress: "We couldn't update your billing address. Please try again.",
  unableToUpdateDeliveryOption: "We couldn't update your selection. Please try again.",
  unableToUpdateShippingAddressToCart: "We couldn't save updates to your shipping address. Please try again",
  unableToShipToAddress: "We are unable to ship to this address. Please try a different address, or try again.",
  generalError: "There was an error processing your request. Please try again.",
  fullPageError: `Sending your cart to checkout didn't stick.\n
  Wait a few seconds and refresh the page or return to your cart.\n
  If you're still having issues after a few minutes, contact our helpful customer service team`,
  invalidEmail: "Please enter a valid email address.",
  unableToDeleteAddress: "We couldn't delete your address. Please try again.",
  unableToDeleteSavedCard: "We couldn't delete your card. Please try again.",
  unableToSetRushOrder: "We couldn't set your rush order. Please try again.",
  unableToDuplicateItem: "We couldn't duplicate your item. Please try again.",
  unableToRemoveItem: "We couldn't remove your item. Please try again.",
  unableToUpdateItemQty: "We couldn't update your quantity. Please try again.",
  genericErrorMessage: "We’re sorry, something went wrong. Please try again.",
  invalidPromoCode: "Invalid promo code.",
  promoCodeRequired: "Please enter a promo code.",
  unableToApplyPromo: "We couldn't apply your promo code. Please try again.",
  promoCodeCustomerRestricted: "Promo code is not valid for your account.",
  promoCodeExcessiveItemQuantity: "Item quantity exceeds the promo code requirements.",
  promoCodeExcessiveItemValue: "Item value exceeds the promo code requirements.",
  promoCodeExcessiveOrderSize: "Order size exceeds the promo code requirements.",
  promoCodeExcessiveOrderValue: "Order value exceeds the promo code requirements.",
  promoCodeInsufficientItemQuantity: "Item quantity minimum has not been met.",
  promoCodeInsufficientItemValue: "Item value minimum has not been met.",
  promoCodeInsufficientOrderSize: "Order size minimum has not been met.",
  promoCodeInsufficientOrderValue: "Order value minimum has not been met.",
  promoCodeInsufficientUsesRemaining: "Promo code has reached its maximum uses.",
  promoCodeReorderRestricted: "Promo code is only valid for reorders.",
  promoCodeItemRestricted: "No items in your cart are eligible for this promo code.",
  promoCodeMaximumCustomerUsesReached: "You have reached the maximum uses for this promo code.",
  promoCodeNoApplicableItems: "Promo code does not apply to any items in your cart.",
  promoCodeExpired: "Promo code has expired.",
  promoCodeGreaterDiscountExists: "A greater discount has already been applied.",
  promoCodeInactive: "Promo code is inactive.",
  promoCodeForNewCustomersOnly: "Valid only for new customers",
  invalidItemDimensions: "One or more items in your cart do not meet the size requirements.",
};
